<template>
  <div class="wrapper ff-text">
    <PageSection
      v-for="(section, index) in sections"
      :key="`${index}-section`"
      :section="section"
      :class="{}"
      render-mode="hlp"
    />
  </div>
</template>

<script setup lang="ts">
import { QueryTypes } from '~/server/utils/contentstack';
import { contentstackRequest } from '~/util/contentstack/api';
import { getFirstIndex } from '~/util/arrays';
import { metaGen } from '~/util/metadata';
import { useRootStore } from '~/store';

const rootStore = useRootStore();
const route = useRoute();
const { locale } = useI18n();
const event = useRequestEvent();

const slug = route.params.slug as string;

const { data: asyncData, error: asyncError } = await useAsyncData(async () => {
  const response = await contentstackRequest(QueryTypes.hlp, `/hlp/${slug}`, {
    event,
    query: {
      locale: locale?.value,
    },
  });
  const page = getFirstIndex((response?.data as any)?.all_hype_landing_page?.items);

  if (!page) throw createError({ statusCode: 404, message: 'Page not found' });

  return {
    page,
  };
});

useAsyncErrorHandling({
  error: asyncError.value,
});

const state = reactive({
  page: asyncData.value?.page || ({} as any),
});

useHead({
  ...(metaGen(rootStore?.brandSettings, {
    ...(state?.page?.seo || {}),
  }) as any),
});

const sections = computed(() => state.page?.sections || []);

onMounted(() => {
  const { $bus }: any = useNuxtApp();
  $bus.emit('pageView', {
    url: document.URL,
  });
});
</script>
